import { cert } from '@zap-onboard/api-client';
import { useHandlerQuery } from '../../useHandlerQuery';

export const useCertSummary = (
  args: Parameters<cert.Client['getBusinessOverview']>[0],
) =>
  useHandlerQuery((api) => api.cert().getBusinessOverview(args), {
    key: ['BUSINESS_CERT_SUMMARY', args],
  });
